import { createReducer } from '@reduxjs/toolkit';
import { importCommonInfo } from '../actions/commonInfoActions';

export interface CommonInfoState {
    googleMapApiKey: string | null;
}

export const commonInfoReducer = createReducer<CommonInfoState>({ googleMapApiKey: null }, (builder) => {
    builder.addCase(importCommonInfo.fulfilled, (state: CommonInfoState, action: any) => {
        state.googleMapApiKey = action.payload.googleMapsApiKey ?? '';
    });
});
